import * as types from './mutation-types';

export default {
  [types.SET_EXPORT](state, currentExport) {
    state.currentExport = currentExport;
  },
  [types.SET_EXPORT_LIST](state, currentExportList) {
    state.currentExportList = currentExportList;
  },
  [types.SET_EXPORT_LAYOUT](state, currentExportLayout) {
    state.currentExportLayout = currentExportLayout;
  },
  [types.SET_PAGE](state) {
    state.totalPages = state.totalPages + 1;
  },
  [types.RESET_PAGE](state) {
    state.totalPages = 0;
  },
  [types.SET_INDEX_PAGE](state, pageNumber) {
    state.indexPages = pageNumber;
  },
  [types.UPDATE_LOGO](state, logo) {
    state.currentExport.logo_url = logo;
  },
  [types.UPDATE_COMMENT](state, comment) {
    state.globalComment = comment;
  },
};
